import React from "react";
import BaseIcon from "../BaseIcon";
import PropTypes from "prop-types";
import "./style.scss";
const actionTypes = {
  positive: "game_button_positive",
  negative: "game_button_negative",
  neutral: "game_button_neutral",
};
const swipeLastAnswer = {
  1: "game_button_positive",
  3: "game_button_negative",
  2: "game_button_neutral",
};
export default function StaticCardActionBtn({
  type,
  typeAnswer,
  className,
  wrapperStyle,
  onClick,
}) {
  StaticCardActionBtn.propTypes = {
    type: PropTypes.string,
    className: PropTypes.string,
    wrapperStyle: PropTypes.string,
    typeAnswer: PropTypes.number,
    onClick: PropTypes.func,
  };
  const cls = [];
  const wrapperCls = [];
  if (className) cls.push(className);
  if (wrapperStyle) wrapperCls.push(wrapperStyle);
  return (
    <BaseIcon
      onClick={onClick}
      name={type ? actionTypes[type] : swipeLastAnswer[typeAnswer]}
      className={cls.join(" ")}
      iconWrapperStyle={wrapperCls.join(" ")}
    />
  );
}
